import { useAppKit, useAppKitState } from '@reown/appkit/react';
import { useContext, useEffect, useState, useRef } from 'react';
import { connectionContext } from '../../../../../app/connect-wallet/ConnectionStatus';
import { useDisconnect, useAccountEffect, useAccount } from 'wagmi';
import SVG from 'react-inlinesvg';
import { checkAdminWalletAddress, disconnectWallet } from '../../../../../store/actions/index';
import { useDispatch, useSelector } from 'react-redux';
import { toast, ToastContainer } from 'react-toastify';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { toAbsoluteUrl } from '../../../../_helpers';

export const ConnectWallet = () => {
  const { open } = useAppKit();

  const [isWalletConnected, setIsWalletConnected] = useState(false);

  const { loading, message, error, currentAdmin: admin } = useSelector((state) => state.adminAuth);

  const { isConnected, isReconnecting, isConnecting, isDisconnected, isFetchingBalance, balance } = useContext(connectionContext);

  const { address } = useAccount();

  const [currentAddress, setAddress] = useState(null);
  // const modalEvents = useWeb3ModalEvents();
  const { open: isOpen } = useAppKitState();
  const { disconnect } = useDisconnect();
  const dispatch = useDispatch();

  // useAccountEffect({
  //   onDisconnect() {
  //     // setIsWalletConnected(false);
  //     // dispatch(disconnectWallet());
  //     // setAddress(null);

  //     if (!error) {
  //       toast.success("Wallet disconnected successfully");
  //     }
  //   },
  // });

  useEffect(() => {
    if (isDisconnected) {
      setIsWalletConnected(false);
      dispatch(disconnectWallet());
      setAddress(null);
    }

    // if (!error) {
    //   toast.success("Wallet disconnected successfully");
    // }
  }, [isDisconnected]);

  useEffect(() => {
    if (address !== currentAddress && isConnected && isWalletConnected) {
      disconnect();
      setIsWalletConnected(false);
      setAddress(null);
    }
    if (address && !currentAddress) {
      setAddress(address);
      setIsWalletConnected(true);
      dispatch(checkAdminWalletAddress(admin._id, address));
    }
  }, [address, isWalletConnected, currentAddress, disconnect]);

  useEffect(() => {
    if (error) {
      disconnect();
      // toast.error(error);
    }
    // console.log({ error });
  }, [error]);

  return (
    <>
      <OverlayTrigger
        placement='bottom'
        overlay={<Tooltip>{isReconnecting || isConnecting || isOpen ? '...' : isConnected ? 'Disconnect Wallet' : 'Connect Wallet'}</Tooltip>}
      >
        <button className='btn header-icon-btn py-2 px-3' onClick={() => open()}>
          {isReconnecting || isConnecting || isOpen ? (
            // modalEvents.data.event === "CLICK_NETWORKS"
            '...'
          ) : isConnected ? (
            <span className='svg-icon-success'>
              <SVG height={20} width={20} src={toAbsoluteUrl('media/svg/icons/General/wallet-icon.svg')} />
            </span>
          ) : (
            <span className='svg-icon'>
              <SVG height={20} width={20} src={toAbsoluteUrl('media/svg/icons/General/wallet-icon.svg')} />
            </span>
          )}
        </button>
      </OverlayTrigger>
    </>
  );
};
